import { useQuery } from "@tanstack/react-query"
import { useAxios } from "../../contexts/AxiosContext"
import { BILLING_STATUS_KEY } from "../../constants"
import useWorkspace from "../../components/hooks/workspace/useWorkspace"
import { BillingStatus } from "../../types"

type BillingStatusResponse = {
  status: BillingStatus | null
  isLoading: boolean
  error: unknown
}

type UseGetBillingStatusOptions = {
  enabled?: boolean
  refetchInterval?: number | false
}

const useGetBillingStatus = (options: UseGetBillingStatusOptions = {}): BillingStatusResponse => {
  const { axiosApiInstance } = useAxios()
  const { workspace } = useWorkspace()
  const enabled = options.enabled ?? true
  const workspaceId = workspace?.id

  const { data: status, isLoading, error } = useQuery({
    queryKey: [BILLING_STATUS_KEY, workspaceId],
    queryFn: async (): Promise<BillingStatus> => {
      const response = await axiosApiInstance.get<BillingStatus>(`/billing/${workspaceId}/status`)
      return response.data
    },
    refetchInterval: options.refetchInterval,
    enabled: enabled && !!workspaceId,
  })

  return { status: status ?? null, isLoading, error }
}

export default useGetBillingStatus
